"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _edSystem = require("@eduact/ed-system");
var _Spacer = _interopRequireDefault(require("../../Spacer"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Question = require("../Question.styled");
var _templateObject, _templateObject2;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var McqQuestion = function McqQuestion(_ref) {
  var question = _ref.question,
    onChange = _ref.onChange;
  var handleOnChange = function handleOnChange(e) {
    onChange({
      answer: e.target.value
    });
  };
  var handleOnSpanClick = function handleOnSpanClick(value) {
    onChange({
      answer: value
    });
  };
  return /*#__PURE__*/_react["default"].createElement(_Spacer["default"], {
    p: {
      sm: '1rem'
    }
  }, /*#__PURE__*/_react["default"].createElement(_Question.QuestionContentWrapper, {
    dangerouslySetInnerHTML: {
      __html: question.content
    }
  }), /*#__PURE__*/_react["default"].createElement(_Spacer["default"], {
    mb: {
      sm: '0.813rem',
      lg: '2.313rem'
    }
  }), /*#__PURE__*/_react["default"].createElement(_edSystem.FlexLayout, {
    px: {
      sm: '0.813rem'
    },
    flexDirection: "column"
  }, /*#__PURE__*/_react["default"].createElement(AnswersLabel, {
    fontSize: {
      sm: '0.5rem',
      lg: '1rem'
    },
    fontFamily: "Roboto"
  }, "Answers"), /*#__PURE__*/_react["default"].createElement(_Spacer["default"], {
    mb: {
      sm: '6px',
      lg: '1rem'
    }
  }), /*#__PURE__*/_react["default"].createElement(_edSystem.FlexLayout, {
    flexDirection: 'column'
  }, question.options.map(function (mcqItem, index) {
    return /*#__PURE__*/_react["default"].createElement(_edSystem.FlexLayout, {
      alignItems: 'center',
      key: "".concat(mcqItem, "-").concat(index),
      mb: {
        sm: '0.75rem'
      }
    }, /*#__PURE__*/_react["default"].createElement(StyledRadioButton, {
      onChange: handleOnChange,
      type: 'radio',
      id: mcqItem,
      checked: question.answer && question.answer.answer === mcqItem,
      value: mcqItem,
      name: "answer-".concat(question.id)
    }), /*#__PURE__*/_react["default"].createElement(_Spacer["default"], {
      mx: {
        sm: '4px'
      }
    }), /*#__PURE__*/_react["default"].createElement(_edSystem.Typography, {
      cursor: 'pointer',
      onClick: function onClick() {
        return handleOnSpanClick(mcqItem);
      },
      fontSize: {
        sm: '0.75rem',
        lg: '1.125rem'
      }
    }, /*#__PURE__*/_react["default"].createElement("span", null, mcqItem)));
  }))));
};
var _default = McqQuestion;
exports["default"] = _default;
var StyledRadioButton = _styledComponents["default"].input(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\twidth: 1rem;\n\theight: 1rem;\n\t", "\n"])), function (_ref2) {
  var theme = _ref2.theme;
  return "".concat(theme.mediaQueries.large, "{\n\t\twidth :1.25rem;\n\t\theight :1.25rem;\n\t}");
});
var AnswersLabel = (0, _styledComponents["default"])(_edSystem.Typography)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\tcolor: ", ";\n"])), function (props) {
  return props.theme.colors.silver;
});